import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
    const navigate = useNavigate();

    useEffect(() => {
        setTimeout(() => navigate("/"), 5000);
    }, [navigate]);

    return (
        <div>
            <h1>Access Denied</h1>
            <p>You are not authorized to access this application.</p>
            <a href="/">Return to Home</a>
        </div>
    );
};

export default Unauthorized;